import React from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import Table from '../../components/ui/Table';
import { useToast } from '../../components/ui/Toast';
import { products } from '../../data/mockData';
import { Download, Zap } from 'lucide-react';

export default function CriticalExpiry() {
  const toast = useToast();

  const critical = [...products]
    .filter(p => p.daysUntilExpiry <= 5)
    .sort((a, b) => a.daysUntilExpiry - b.daysUntilExpiry);

  const columns = [
    {
      key: 'name', label: 'Товар',
      render: (v, row) => (
        <div>
          <div style={{ fontWeight: 600, fontSize: 13 }}>{v}</div>
          <code style={{ fontSize: 11, color: '#8E8E93' }}>{row.barcode}</code>
        </div>
      )
    },
    { key: 'category', label: 'Категория', render: v => <Badge variant="primary">{v}</Badge> },
    { key: 'stockQuantity', label: 'Остаток', render: (v, row) => <span style={{ fontWeight: 600 }}>{v} {row.unit}</span> },
    {
      key: 'nearestExpiry', label: 'Дата истечения',
      render: (v, row) => (
        <span style={{ fontWeight: 700, color: row.daysUntilExpiry < 0 ? '#FF3B30' : row.daysUntilExpiry <= 3 ? '#FF6B6B' : '#FF9500' }}>
          {new Date(v).toLocaleDateString('ru-RU')}
        </span>
      )
    },
    {
      key: 'daysUntilExpiry', label: 'Статус',
      render: v => v < 0
        ? <Badge variant="error">🔴 Просрочен {Math.abs(v)} дн. назад</Badge>
        : v === 0
        ? <Badge variant="error">🔴 Истекает сегодня!</Badge>
        : v <= 3
        ? <Badge variant="urgent">🟠 Осталось {v} дн.</Badge>
        : <Badge variant="warning">🟡 Осталось {v} дн.</Badge>
    },
    {
      key: 'actions', label: '', sortable: false,
      render: (_, row) => (
        <div style={{ display: 'flex', gap: 6 }} onClick={e => e.stopPropagation()}>
          <button onClick={() => toast(`Задача ОСГ создана для "${row.name}"`, 'success')} style={{ fontSize: 11, padding: '5px 10px', borderRadius: 6, border: '1px solid #4A6CF7', background: '#EEF2FF', cursor: 'pointer', color: '#4A6CF7', fontFamily: 'inherit', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
            <Zap size={11} />Создать задачу
          </button>
          <button onClick={() => toast(`"${row.name}" помечен как обработан`, 'success')} style={{ fontSize: 11, padding: '5px 10px', borderRadius: 6, border: '1px solid #E5E7EB', background: '#fff', cursor: 'pointer', color: '#34C759', fontFamily: 'inherit' }}>Обработано</button>
          <button onClick={() => toast(`"${row.name}" списан`, 'warning')} style={{ fontSize: 11, padding: '5px 10px', borderRadius: 6, border: '1px solid #FEE2E2', background: '#FFF0F0', cursor: 'pointer', color: '#FF3B30', fontFamily: 'inherit' }}>Списать</button>
        </div>
      )
    }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Критические сроки годности</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Автообновляемый список товаров с ближайшими сроками</p>
        </div>
        <Button variant="secondary" icon={<Download size={14} />} onClick={() => toast('Экспорт CSV', 'success')}>Экспорт CSV</Button>
      </div>

      <div style={{ padding: '14px 18px', background: '#FFF5F5', border: '1px solid #FECACA', borderRadius: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 24 }}>⚠️</span>
        <div>
          <div style={{ fontWeight: 700, color: '#DC2626', fontSize: 14 }}>Требуется внимание!</div>
          <div style={{ fontSize: 13, color: '#7F1D1D' }}>{critical.filter(p => p.daysUntilExpiry <= 0).length} товаров просрочено, {critical.filter(p => p.daysUntilExpiry > 0 && p.daysUntilExpiry <= 3).length} товаров истекает в ближайшие 3 дня</div>
        </div>
      </div>

      <Card padding="0">
        <Table columns={columns} data={critical} emptyText="Критических сроков нет" />
      </Card>
    </div>
  );
}
